export const NO_VALUE_DASH = '-';
